<template>
  <div class="hot-topic-item" @click="goDetail">
    <img class="hot-topic-item-img" :src="hotTopic.coverPhoto.url" alt="专题图片" />
    <div class="hot-topic-item-nums">
      <div>{{pageview}} 看过</div>
      <div>{{hotTopic.topicArticles && hotTopic.topicArticles.length || 0}} 篇{{isArticle}}</div>
    </div>
    <div class="hot-topic-item-bottom">
      <div class="hot-topic-item-title">
        <div>{{hotTopic.title}}</div>
      </div>
      <div class="hot-topic-item-content">{{hotTopic.post || hotTopic.text}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hot-topic-item",
  props: {
    hotTopic: Object,
  },
  computed: {
    pageview() {
      return (
        this.hotTopic &&
        this.hotTopic.topicArticles &&
        this.hotTopic.topicArticles
          .map((e) => e.pageview)
          .reduce((total, pv) => total + pv)
      );
    },
    isArticle () {
      const articleType = this.hotTopic.topicArticles && this.hotTopic.topicArticles[0] && this.hotTopic.topicArticles[0].articleType
      return articleType === '0' ? '文章' : articleType === '1' ? '课程' : '内容'
    }
  },
  data() {
    return {};
  },
  methods: {
    goDetail() {
      window.open("/topicdetail/" + this.hotTopic._id);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.hot-topic-item {
  width: 261px;
  border-radius: 6px;
  position: relative;
  margin-bottom: 36px;
  height: 250px;
  &:hover {
    cursor: pointer;
    box-shadow: 0px 0px 16px 0px rgba(51, 51, 51, 0.1);
    .item-button {
        background-color: #e70012;
        color: #ffffff;
        border-color: #e70012 !important;
    }
  }
  > .hot-topic-item-img {
    width: 261px;
    height: 117px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  > .hot-topic-item-nums {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 18px;
    position: absolute;
    top: 92px;
    width: 261px;
    height: 25px;
    background-color: rgba(255, 255, 255, 0.8);
  }
  > .hot-topic-item-bottom {
    border: 1px solid #eaeaea;
    border-radius: 0 0 4px 4px;
    border-top: none;
    padding-top: 18px;
    padding-bottom: 20px;
    > .hot-topic-item-title {
      padding:0 18px;
      text-align: left;
      height: 40px;
      margin-bottom: 8px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      > div {
        padding-left: 7px;
        color: #333333;
        font-weight: bold;
        font-size: 16px;
        border-left: 4px solid #e70012;
        line-height: 19px;
      }
    }
    > .hot-topic-item-content {
      text-align: left;
      padding: 0 18px;
      font-size: 13px;
      color: #999999;
      line-height: 21px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
      height: 44px;
    }
  }
}
</style>
